import { render, staticRenderFns } from "./InventoryDocumentSearch.vue?vue&type=template&id=8607969c&scoped=true&"
import script from "./InventoryDocumentSearch.vue?vue&type=script&lang=ts&"
export * from "./InventoryDocumentSearch.vue?vue&type=script&lang=ts&"
import style0 from "./InventoryDocumentSearch.vue?vue&type=style&index=0&id=8607969c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8607969c",
  null
  
)

export default component.exports